import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { TwoFactorAuthService } from '../../../../../../coverpath-common/angular/services/twoFactorAuth/twoFactorAuth.service';
import { AmorphicService } from '../../../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { TwoFactorAuthStatus } from '../../../../../../coverpath-common/angular/classes/TwoFactorAuthStatus';
import { Controller } from '../../../Controller';
import { TwoFactorAuthScreen } from '../../../classes/login/TwoFactorAuthScreen';
import { FormatterService } from '../../../../../../coverpath-common/angular/services/formatter/formatter.service';
import { CPLogger } from '../../../../../../common/js/logger/CPLogger';
@Component({
  moduleId: module.id,
  selector: 'two-factor-auth',
  templateUrl: './two-factor-auth.component.html',
})
export class TwoFactorAuthComponent implements OnInit {
  @Output() onTFAComponentClose = new EventEmitter<boolean>();
  code: number;
  errorMessage: string;
  displayPhone: string;
  twoFactorAuthScreen: { [s: number]: string } = TwoFactorAuthScreen;
  currentScreen: TwoFactorAuthScreen = TwoFactorAuthScreen['Verify'];
  tfaDown: boolean = false;
  controller: Controller;
  method: string;
  advisorName: string;
  advisorEmail: string;
  advisorNumber: string;
  formattedAdvisorNumber: string;

  constructor(
    private twoFactorAuthService: TwoFactorAuthService,
    private amorphicService: AmorphicService,
    private formatterService: FormatterService
  ) {
    this.controller = this.amorphicService.controller as Controller;
  }

  ngOnInit(): void {
    this.twoFactorAuthService.getTFAPhone().then((phone) => {
      this.displayPhone = phone;
      this.sendCode('sms', false);
    });

    this.advisorEmail = this.controller.customer.application.primaryPolicy.primaryPolicyAgent.primaryAgent.person.email;
    this.advisorName =
      this.controller.customer.application.primaryPolicy.primaryPolicyAgent.primaryAgent.person.getFullName();
    this.advisorNumber =
      this.controller.customer.application.primaryPolicy.primaryPolicyAgent.primaryAgent.person.phone.number;
    this.formattedAdvisorNumber = this.formatterService.format('telephone', this.advisorNumber);
  }

  submit(): void {
    this.twoFactorAuthService
      .submitAndVerifyTFACode(this.code)
      .then(() => {
        this.exit(true);
      })
      .catch((error) => {
        if (error === TwoFactorAuthStatus.locked) {
          this.currentScreen = TwoFactorAuthScreen['Locked'];
        } else if (error === TwoFactorAuthStatus.expired) {
          this.errorMessage = 'Your code has expired.';
          this.sendCode(this.method, false);
        } else if (error === TwoFactorAuthStatus.invalid) {
          this.errorMessage = 'Incorrect code. Please try again.';
        }
      });
  }

  sendCode(method: string, resend: boolean): void {
    this.method = method; // for sending new code after expiration

    this.twoFactorAuthService.sendTFACodeToPhone(method, resend).catch((error) => {
      if (error === TwoFactorAuthStatus.locked) {
        this.currentScreen = TwoFactorAuthScreen['Locked'];
      } else if (error === TwoFactorAuthStatus.no_response) {
        this.controller.emailNotificationController.sendEmailNotification(
          'twoFactorAuthErrorEmail',
          this.controller.customer.email
        );
        this.errorMessage = 'Sorry! Something went wrong. Please contact customer support';
      } else {
        this.errorMessage = error;
      }
    });
  }

  exit(continueLogin?: boolean): void {
    this.onTFAComponentClose.emit(continueLogin);
  }

  goToScreen(screen: TwoFactorAuthScreen): void {
    this.currentScreen = screen;
  }

  clearErrors(): void {
    this.errorMessage = null;
  }
}
